import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { RootStateContext } from "@/data/RootStateProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendEvent } from "@/utils/Analytics";
import { ChannelRemind } from "@/utils/UrlHelper";
import React from "react";
import DownloadTip from "../DownloadTip";
import style from "./style.less";

const HomeHeader = () => {
  const { getPersist, setPersist } = React.useContext(PersistContext);
  const { rootState, setRootStateKey } = React.useContext(RootStateContext);
  const history = useEnhancedHistory();

  const toggleSidebar = () => {
    console.log("toggleSidebar");
    console.log("rootState.sidebarOpened", rootState.sidebarOpened);
    if (rootState.sidebarOpened) {
      setRootStateKey("sidebarOpened", false);
    } else {
      setRootStateKey("sidebarOpened", true);
    }
  };
  const [downloadTipClosed, setDownloadTipClosed] = React.useState(true);
  React.useEffect(() => {
    setDownloadTipClosed(getPersist("downloadTipClosed"));
  }, [getPersist("downloadTipClosed")]);

  const userInfo = getPersist("user_info");
  let nowLocationInfo = LocationInfo();
  console.log("nowLocationInfo", nowLocationInfo);
  return (
    <div class={style.outline}>
      {downloadTipClosed ? null : <DownloadTip onClose={() => setPersist("downloadTipClosed", true, 3 * 24 * 3600)} />}
      <div class={style.header_content}>
        <div class={`${style.header_two_separate} ${style.header_left}`}>
          <img src={require("@/assets/icon.png").default} style={{ width: "1.4rem", marginLeft: "0.54rem" }} />
          <div style={{ fontSize: "1.1rem" }}>
            <img
              src={require("@/assets/images/header/fz_char_logo.png").default}
              style={{ height: ".99rem", margin: "0 0 0 .6rem" }}
            />
          </div>
        </div>
        <div class={`${style.header_two_separate} ${style.header_right_index}`}>
          {userInfo && userInfo.rid ? (
            <>
              <div class={style.balance}>
                <img src={require("@/assets/images/home/wallet.png").default} style={{ width: "1.2rem", zIndex: 10 }} />
                <div class={style.balance_coin}>
                  {nowLocationInfo.currency}: {(userInfo.money.coin / 100).toFixed(2)}
                </div>
              </div>
              <div
                onClick={() => {
                  SendEvent("home_header_deposit_click", {});
                  history.push(ChannelRemind("./deposit"));
                }}
              >
                <div class={style.header_deposit_btn_index}>Deposit</div>
              </div>
            </>
          ) : (
            <>
              <div
                onClick={() => {
                  SendEvent("home_header_register_click", {});
                  history.push(ChannelRemind("/login?reg=1"));
                }}
              >
                <div class={style.header_join_btn}>
                  <img class={style.send_money_anim} src={require("@/assets/images/home/SendMoney.png").default} style={{
                    position: "absolute",
                    height: "0.8rem",
                    width: "auto",
                    marginLeft: "-1.9rem",
                    marginTop: "-0.8rem",
                  }} />
                  <span>Join</span>
                </div>
              </div>
              <div
                onClick={() => {
                  SendEvent("home_header_login_click", {});
                  setPersist("isLogin", true);
                  history.push(ChannelRemind("/login"));
                }}
              >
                <div class={style.header_login_btn_index}>
                  <span>Login</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeHeader;
